// extracted by mini-css-extract-plugin
export default {"chat":"_23dV","chatContainer":"aboE","separator":"_1MaL"};